import { render, staticRenderFns } from "./SettingsBody.vue?vue&type=template&id=4262908c&"
import script from "./SettingsBody.vue?vue&type=script&lang=js&"
export * from "./SettingsBody.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBody.vue?vue&type=style&index=0&id=4262908c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports